import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import {
  CreateHangfireRecurringJobDTO,
  HangfireRecurringJobDTO,
} from '../interfaces/hangfire-recurring-job';
import { WebApiMessageOnly } from '../interfaces/web-api-message';
import { IHangfireECSTaskInfo } from '../interfaces/system-settings/hangfire-ecs/hangfire-ecs-task-info';

@Injectable({ providedIn: 'root' })
export class HangfireRecurringJobService {
  url = '/api/HangfireRecurringJob';

  constructor(private http: HttpClient, private handlersFactory: HttpResponsesHandlersFactory) {}

  public getAvailableMethods(): Promise<string[]> {
    return this.http.get<string[]>(`${this.url}/available`).toPromise();
  }

  public getAll(): Promise<HangfireRecurringJobDTO[]> {
    return this.http.get<HangfireRecurringJobDTO[]>(this.url).toPromise();
  }

  public create(dto: CreateHangfireRecurringJobDTO): Promise<WebApiMessageOnly> {
    return this.http.post<WebApiMessageOnly>(`${this.url}`, dto).toPromise();
  }

  public updateSchedule(jobId: number, cronExpression: string): Promise<WebApiMessageOnly> {
    return this.http
      .post<WebApiMessageOnly>(`${this.url}/${jobId}/schedule`, { cronExpression })
      .toPromise();
  }

  public deactivate(id: number): Promise<WebApiMessageOnly> {
    return this.http.post<WebApiMessageOnly>(`${this.url}/${id}/deactivate`, {}).toPromise();
  }

  public pauseAlgoEtlQueue(): Promise<void> {
    return this.http.post<void>(`${this.url}/pause-etl-queue`, {}).toPromise();
  }

  public startStopHangfireECSService(): Promise<void> {
    return this.http.post<void>(`${this.url}/ecs/start-stop`, {}).toPromise();
  }

  public getHangfireECSServiceOverview(): Promise<IHangfireECSTaskInfo[]> {
    return this.http.get<IHangfireECSTaskInfo[]>(`${this.url}/ecs/overview`).toPromise();
  }

  public getHangfireECSTaskCount(): Promise<number> {
    return this.http.get<number>(`${this.url}/ecs/taskCount`).toPromise();
  }
}
